import { RefObject, useContext } from 'react';
import RouteSkeleton from './RouteSkeleton';
import { RouteDetail } from './RouteDetail';
import { DetailedRoute } from '@/generated/model/detailedRoute';
import { addListSeparatorLine } from '@/components/common/ListSeparator';
import { ctxRoutes } from '@/contexts/RoutesCtx';
import { useTranslation } from 'react-i18next';
type RouteListProps = {
  routesByTimes: Record<string, Array<DetailedRoute | undefined>>;
  showTooltip: boolean;
  refs: RefObject<Map<string, RefObject<HTMLDivElement | null>>>;
  registerRef: (route: DetailedRoute | undefined) => (el: HTMLElement | null) => void;
};

export default function RouteList({ routesByTimes, showTooltip, refs, registerRef }: RouteListProps) {
  const routeCtx = useContext(ctxRoutes);
  const { t } = useTranslation();

  if (routeCtx?.routesLoading) {
    return (
      <>
        <RouteSkeleton key={1} />
        <RouteSkeleton key={2} />
        <RouteSkeleton key={3} />
      </>
    );
  }

  return (
    <>
      {Object.keys(routesByTimes).map((date, index) => (
        <div ref={refs.current.get(date)} key={date} style={{ position: 'relative' }}>
          {showTooltip && index === 0 && routeCtx?.routes && routeCtx?.routes.length > 0 && (
            <div className="route-detail-highlight-tooltip" data-qa-element-id="select_routes_tooltip">
              {t('routes.highlightTooltip')}
            </div>
          )}
          <span
            data-qa-element-id={`day_separator_for_date_${date
              .replace(/\([^)]*\)/g, '')
              .replace(/\s*->\s*/g, '-')
              .trim()}`}
          >
            {addListSeparatorLine(date)}
          </span>

          {routesByTimes[date].map((route) => (
            <RouteDetail
              key={route ? route.id : -1}
              route={route}
              className={showTooltip ? 'route-highlight-tooltip' : ''}
              ref={registerRef(route)}
            />
          ))}
        </div>
      ))}
    </>
  );
}
